import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { push } from "connected-react-router";

import * as rfqApi from "@/api/rfq";

import {
  FETCH_RFQ,
  PATCH_RFQ,
  PATCH_RFQ_POSITION,
  FETCH_RFQ_START,
  FETCH_RFQ_FAIL,
  FETCH_RFQ_SUCCESS,
  PATCH_RFQ_START,
  PATCH_RFQ_SUCCESS,
  PATCH_RFQ_FAIL,
  SUBMIT_RFQ,
  SUBMIT_RFQ_START,
  SUBMIT_RFQ_SUCCESS,
  SUBMIT_RFQ_FAIL,
} from "../../reducers/shopping/rfq/actions";

import { FETCH_CART } from "@/reducers/shopping/cart/actions";

function* fetchRfq({ payload, meta }) {
  try {
    const rfqId = payload;
    yield put({ type: FETCH_RFQ_START, payload: rfqId });
    const rfq = yield call(rfqApi.fetchRfq, rfqId);
    yield put({ type: FETCH_RFQ_SUCCESS, payload: rfq, meta });
  } catch (err) {
    yield put({ type: FETCH_RFQ_FAIL, payload: err, error: true, meta });
  }
}

function* patchRfq({ payload, meta }) {
  try {
    const { rfqId, data } = payload;
    yield put({ type: PATCH_RFQ_START, payload: rfqId });
    const rfq = yield call(rfqApi.patchRfq, rfqId, data);
    yield put({ type: PATCH_RFQ_SUCCESS, payload: rfq, meta });
    yield put(push(`/shopping/rfq/${encodeURIComponent(rfqId)}/checkout`));
  } catch (err) {
    yield put({ type: PATCH_RFQ_FAIL, payload: err, error: true, meta });
  }
}

function* patchRfqPosition({ payload, meta }) {
  try {
    const { rfqId, positionId, data } = payload;
    yield put({ type: PATCH_RFQ_START, payload: rfqId });
    const rfq = yield call(rfqApi.patchRfqPosition, rfqId, positionId, data);
    yield put({ type: PATCH_RFQ_SUCCESS, payload: rfq, meta });
  } catch (err) {
    yield put({ type: PATCH_RFQ_FAIL, payload: err, error: true, meta });
  }
}

function* submitRfq({ payload, meta }) {
  const { rfqId, data } = payload;
  try {
    yield put({ type: SUBMIT_RFQ_START, payload: rfqId });
    const rfq = yield call(rfqApi.submitRfq, rfqId, data);
    yield put({ type: SUBMIT_RFQ_SUCCESS, payload: rfq });
    yield put(push(`/shopping/rfq/${encodeURIComponent(rfqId)}/confirmation`));
    yield put({ type: FETCH_CART });
  } catch (err) {
    yield put({ type: SUBMIT_RFQ_FAIL, payload: err, error: true, meta });
    yield put({ type: FETCH_RFQ, payload: rfqId });
    yield put(push(`/shopping/rfq/${encodeURIComponent(rfqId)}/error`));
  }
}

export default function* rfqSaga() {
  yield takeLatest(FETCH_RFQ, fetchRfq);
  yield takeEvery(PATCH_RFQ, patchRfq);
  yield takeEvery(PATCH_RFQ_POSITION, patchRfqPosition);
  yield takeEvery(SUBMIT_RFQ, submitRfq);
}
